import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSatellite = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-satellite';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M15.13 3.282a5 5 0 0 0-2.654 1.025c-.578.435-1.118 1.059-1.432 1.656l-.136.259-3.613 1.859C5.308 9.103 3.681 9.956 3.681 9.977a25 25 0 0 0 .661 1.296c.006.008 1.232-.616 2.725-1.385a900 900 0 0 1 3.038-1.561l.325-.163.005.394c.012.912.325 1.925.821 2.66l.188.278-2.882 2.882L5.68 17.26l.53.53.53.53 2.882-2.882 2.882-2.882.278.188c.771.52 1.782.818 2.78.819.264 0 .473.013.463.029-.093.154-3.271 5.99-3.277 6.019-.004.021.28.197.632.392.504.279.648.342.68.301.022-.029.94-1.701 2.04-3.715l2-3.662.205-.123c.305-.183.81-.602 1.072-.89.994-1.092 1.488-2.543 1.346-3.955-.154-1.539-.913-2.864-2.143-3.74a5.2 5.2 0 0 0-3.45-.937m1.37 1.589c1.316.362 2.289 1.345 2.644 2.67.058.218.074.414.072.899-.002.557-.014.657-.111.978-.103.339-.404.982-.46.982-.014 0-1.159-1.134-2.545-2.521-2.031-2.032-2.508-2.529-2.46-2.562.299-.203.913-.439 1.346-.518.318-.057 1.196-.016 1.514.072m-1.44 4.09c2.051 2.051 2.509 2.529 2.46 2.563-.166.117-.739.361-1.04.443-.285.077-.434.091-.92.089-.511-.003-.623-.016-.94-.112-.685-.207-1.162-.487-1.624-.954a3.67 3.67 0 0 1-.963-1.704c-.121-.451-.12-1.257.001-1.746.084-.34.414-1.1.477-1.1.016 0 1.163 1.134 2.549 2.521"
    })
  }));
});
export default SvgSatellite;